import { Injectable } from '@angular/core';
import { CommonService } from '../../shared/common.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AdminLayoutService {
  environment: any;
  loginUserData = localStorage.getItem('adminToken')?.replace(/^"|"$/g, '') || '';
  headersVar = new HttpHeaders({ 'Authorization': `${this.loginUserData}` })

  constructor(public commonService: CommonService, private http: HttpClient) {
    this.setHeaders();
  }

  private setHeaders() {
    // console.log(this.headersVar);
    const loginUserData = localStorage.getItem('adminToken')?.replace(/^"|"$/g, '') || '';
    this.headersVar = new HttpHeaders({ 'Authorization': `${loginUserData}` });
    // console.log(this.headersVar);
  }

  // =====================================================================================================================================================================
  // -----------------------------------------------------------------------| Admin Initialization APIs |------------------------------------------------------------------
  // =====================================================================================================================================================================

  getAdminModulesList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'ModuleMaster/GetMenuAndSubMenuList', { headers: this.headersVar });
  }

  // =====================================================================================================================================================================
  // -----------------------------------------------------------------------| Admin Activity Page APIs |------------------------------------------------------------------
  // =====================================================================================================================================================================

  //Admin Add Activity
  addNewActivity(activityData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'AdminActivity/AddActivityDetails', activityData, { headers: this.headersVar });
  }

  updateActivity(activityData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'AdminActivity/UpdateActivity', activityData, { headers: this.headersVar });
  }

  deleteActivity(activityId: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'AdminActivity/DeleteActivity/' + activityId, {}, { headers: this.headersVar });
  }

  // Admin Get Activity List
  getActivityList(placeId: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'AdminActivity/GetActivity', { params: placeId, headers: this.headersVar });
  }

  // Admin Get Activity List
  getActivityDataById(activityId: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'AdminActivity/' + activityId, { headers: this.headersVar });
  }

  //Add Activity Images
  uploadActivityImages(formData: FormData) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + `AdminActivity/UploadActivityImages`, formData);
  }

  // =====================================================================================================================================================================
  // ------------------------------------------------------------------| Admin Add/Edit Packages Page APIs |--------------------------------------------------------------
  // =====================================================================================================================================================================

  getPackageInfoByPackageId(packageId: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/package/GetPackageDetailsByPackageId/' + packageId, { headers: this.headersVar });
  }

  // Admin Get CheckPoints List
  getCheckpointsList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/CheckPoint/GetCheckPointOfItinerary', { headers: this.headersVar });
  }

  addPackageJSON(packageData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/package/PackageRequest', packageData, { headers: this.headersVar });
  }

  //Admin Add package
  addNewPackage(packageData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/package/CreateAdminPackageAsync', packageData, { headers: this.headersVar });
  }

  confirmPackage(packageId: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/package/ConfirmPackage', packageId, { headers: this.headersVar });
  }

  //Admin Update package
  updatePackage(packageData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/package/UpdateAdminPackageAsync', packageData, { headers: this.headersVar });
  }

  //Upload Package Images
  uploadPackageImages(formData: FormData) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + `admin/package/UploadPackageImages`, formData);
  }

  //Admin Add Checkpoints
  addNewCheckpoints(checkpointsData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/CheckPoint/InsertCheckPointOfItinerary', checkpointsData, { headers: this.headersVar });
  }

  //Admin Add Checkpoints
  addDayWiseItinerary(dayItineraryData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/Itinerary/InsertItinerary', dayItineraryData, { headers: this.headersVar });
  }
  addItineraryDates(itineraryDateData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/PackageDate/InsertPlaceDateDetailsAsync', itineraryDateData, { headers: this.headersVar });
  }

  deleteItineraryDates(itineraryDateId: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/PackageDate/DeletePlacedateAsync/' + itineraryDateId, {}, { headers: this.headersVar });
  }

  getDatesList(packageId: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/PackageDate/GetPlaceDetailsByPackageIdAsync/' + packageId, { headers: this.headersVar });
  }

  addPolicy(policyData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'AdminPolicy/AddPolicies', policyData, { headers: this.headersVar });
  }

  // =====================================================================================================================================================================
  // -----------------------------------------------------------------------| Admin Booking Page APIs |-------------------------------------------------------------------
  // =====================================================================================================================================================================

  // Admin Booking
  getBookingDetails(params) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'AdminBooking/booking-details', { params: params, headers: this.headersVar });
  }

  // =====================================================================================================================================================================
  // -----------------------------------------------------------------------| Admin Category Page APIs |------------------------------------------------------------------
  // =====================================================================================================================================================================

  // Admin Package category
  getPackageCategory() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/packageCategory/GetAllPackageCategory', { headers: this.headersVar });
  }

  // Admin category List
  getCategoryList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/packageCategory/GetAllPackageCategory', { headers: this.headersVar });
  }

  //Admin Add Category
  addCategory(categoryData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/packageCategory/AddPackageCategoryDetails', categoryData, { headers: this.headersVar });
  }

  //Edit category ById 
  GetCategoryById(id: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + `admin/packageCategory/GetPackageCategoryById/` + id, { headers: this.headersVar });
  }

  // Get Data by Id
  getCategoryById(id: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'BookingItinerary/' + id, { headers: this.headersVar });
  }

  // Delete Category ById
  deleteCategory(id: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/packageCategory/DeletePackageCategory/' + id, {}, { headers: this.headersVar });
  }

  // Upadate Category 
  updateCategory(updateCategory: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/packageCategory/UpdatePackageCategory', updateCategory, { headers: this.headersVar });
  }
  
  // =====================================================================================================================================================================
  // ---------------------------------------------------------------------| Admin Divine Being Page APIs |----------------------------------------------------------------
  // =====================================================================================================================================================================
  
  // Admin category List
  getAllDivineBeingList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/adminGod/GetAllGod', { headers: this.headersVar });
  }

  //Edit festival By Id 
  GetDivineBeingById(id: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + `admin/adminGod/GetGodById`, { params: id, headers: this.headersVar });
  }

  //Admin Add Festival
  addDivineBeing(festivalData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/adminGod/AddAdminGod', festivalData, { headers: this.headersVar });
  }

  // Delete festival By Id
  deleteDivineBeing(id: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/adminGod/DeleteAdminGod/' + id, {}, { headers: this.headersVar });
  }

  // Upadate festival 
  updateDivineBeing(updateCategory: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/adminGod/UpdateAdminGod', updateCategory, { headers: this.headersVar });
  }
  
  // =====================================================================================================================================================================
  // ---------------------------------------------------------------------| Admin Trip Feedback Page APIs |----------------------------------------------------------------
  // =====================================================================================================================================================================
  
  // Admin category List
  getAllTripFeedbackList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'AdminTripFeedback/GetAllTripFeedbacks', { headers: this.headersVar });
  }

  //Edit festival By Id 
  GetTripFeedbackById(id: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + `AdminTripFeedback/GetTripFeedbackById`, { params: id, headers: this.headersVar });
  }

  //Admin Add Festival
  addTripFeedback(festivalData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'AdminTripFeedback/AddAdminTripFeedbacks', festivalData, { headers: this.headersVar });
  }

  // Delete festival By Id
  deleteTripFeedback(id: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'AdminTripFeedback/DeleteAdminTripFeedbacks/' + id, {}, { headers: this.headersVar });
  }

  // Upadate festival 
  updateTripFeedback(updateCategory: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'AdminTripFeedback/UpdateAdminTripFeedbacks', updateCategory, { headers: this.headersVar });
  }

  // =====================================================================================================================================================================
  // -----------------------------------------------------------------------| Admin Festival Page APIs |------------------------------------------------------------------
  // =====================================================================================================================================================================
  
  // Admin category List
  getAllFestivalList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/adminFestival/GetAllFestival', { headers: this.headersVar });
  }

  //Edit festival By Id 
  GetFestivalById(id: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + `admin/adminFestival/GetFestivalById`, { params: id, headers: this.headersVar });
  }

  //Admin Add Festival
  addFestival(festivalData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/adminFestival/AddAdminFestival', festivalData, { headers: this.headersVar });
  }

  // Delete festival By Id
  deleteFestival(id: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/adminFestival/DeleteAdminFestival/' + id, {}, { headers: this.headersVar });
  }

  // Upadate festival 
  updateFestival(updateCategory: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/adminFestival/UpdateAdminFestival', updateCategory, { headers: this.headersVar });
  }

  // =====================================================================================================================================================================
  // -------------------------------------------------------------------------| Admin Hotel Page APIs |-------------------------------------------------------------------
  // =====================================================================================================================================================================

  // Admin Hotel List
  getHotelList(placeId: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/Hotel/GetAllHotel', { params: placeId, headers: this.headersVar });
  }
  //Get hotel services
  getHotelServices() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/Hotel/GetHotelAmenities', { headers: this.headersVar });
  }
  //Admin Add Hotel
  addNewHotel(hotelData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/Hotel/InsertHotel', hotelData, { headers: this.headersVar });
  }

  updateHotel(HotelData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/Hotel/UpdateHotelDetails', HotelData, { headers: this.headersVar });
  }

  deleteHotel(HotelId: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/Hotel/DeleteHotelAsync/' + HotelId, {}, { headers: this.headersVar });
  }

  // Admin Get Hotel List
  getHotelDataById(HotelId: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/Hotel/' + HotelId, { headers: this.headersVar });
  }

  addNewHotelRoom(roomData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/Hotel/InsertHotelRoom', roomData, { headers: this.headersVar });
  }

  deleteHotelRoom(roomId: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/Hotel/DeleteHotelRoom/' + roomId, {}, { headers: this.headersVar });
  }

  // Admin Get Hotel List
  getRoomDataById(roomId: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/Hotel/GetRoomDetailsById/' + roomId, { headers: this.headersVar });
  }

  // Admin Get Hotel List
  getRoomDataByHotelId(HotelId: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/Hotel/GetRoomDetailsByHotelId', { params: HotelId, headers: this.headersVar });
  }

  //Upload Hotel Images
  uploadHotelImages(formData: FormData) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + `admin/Hotel/UploadHotelImages`, formData);
  }

  getAdminFoodArrangementList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/Hotel/GetFoodArrangements', { headers: this.headersVar });
  }

  // =====================================================================================================================================================================
  // ------------------------------------------------------------------------| Admin Modules Page APIs |------------------------------------------------------------------
  // =====================================================================================================================================================================

  getModuleList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'ModuleMaster/GetModuleMaster', { headers: this.headersVar });
  }
  getParentModuleList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'ModuleMaster/GetParentModuleList', { headers: this.headersVar });
  }

  addNewModule(moduleData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'ModuleMaster/AddModuleMaster', moduleData, { headers: this.headersVar });
  }

  //Edit module ById 
  GetModuleById(id: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + `ModuleMaster/ModuleMasterById`, { params: id, headers: this.headersVar });
  }

  // Upadate module 
  updateModule(updateModule: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'ModuleMaster/UpdateModuleMaster', updateModule, { headers: this.headersVar });
  }

  deleteModule(id: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'ModuleMaster/' + id, {}, { headers: this.headersVar });
  }

  // =====================================================================================================================================================================
  // -----------------------------------------------------------------------| Admin Packages Page APIs |------------------------------------------------------------------
  // =====================================================================================================================================================================

  // Admin Package
  getPackageDetails(filterTerms: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/package/details', { params: filterTerms, headers: this.headersVar });
  }

  getPackageDetailsById(packageId: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/package/GetItineraryPackageDetailsById/' + packageId, { headers: this.headersVar });
  }

  getItineraryataByPackageId(packageId: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'Itinerary/' + packageId, { headers: this.headersVar });
  }

  

  //Admin deactive active package
  activeDeactivePackage(packageData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/package/Active-DeActivePackage', packageData, { headers: this.headersVar });
  }

  //package priority change
  packagePriorityUpdate(packageData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/package/AdminPackagePriority', packageData, { headers: this.headersVar });
  }

  //package feature change
  packageFeatureUpdate(packageData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/package/PackageFeatured', packageData, { headers: this.headersVar });
  }
  
  //package group change
  packageGroupUpdate(packageData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/package/PackageGrouped', packageData, { headers: this.headersVar });
  }

  //Admin deactive active package
  permanentDeletePackage(packageData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/package/AdminPackageIsPermanentDelete', packageData, { headers: this.headersVar });
  }

  //Admin approve package
  approvePackage(packageData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/package/Approvepackage', packageData, { headers: this.headersVar });
  }

  // =====================================================================================================================================================================
  // -------------------------------------------------------------------| Admin Pilgrim Pathways Page APIs |--------------------------------------------------------------
  // =====================================================================================================================================================================

  // Admin category List
  getAllPilgrimPathList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/adminPilgrimPathway/GetAllPilgrimPathway', { headers: this.headersVar });
  }

  //Edit festival By Id 
  GetPilgrimPathById(id: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + `admin/adminPilgrimPathway/GetAdminPilgrimPathById`, { params: id, headers: this.headersVar });
  }

  //Admin Add Festival
  addPilgrimPath(festivalData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/adminPilgrimPathway/AddAdminPilgrimPath', festivalData, { headers: this.headersVar });
  }

  // Delete festival By Id
  deletePilgrimPath(id: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/adminPilgrimPathway/DeleteAdminPilgrimPath/' + id, {}, { headers: this.headersVar });
  }

  // Upadate festival 
  updatePilgrimPath(updateCategory: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/adminPilgrimPathway/UpdateAdminPilgrimPath', updateCategory, { headers: this.headersVar });
  }
  // =====================================================================================================================================================================
  // ------------------------------------------------------------------------| Admin Places Page APIs |-------------------------------------------------------------------
  // =====================================================================================================================================================================

  getStatesList(countryId: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/place/GetStates', { params: countryId, headers: this.headersVar });
  }

  getCitiesList(stateId: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/place/GetCities', { params: stateId, headers: this.headersVar });
  }

  // Admin Get Place List
  getPlaceList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/place/GetAllPlaces', { headers: this.headersVar });
  }

  getCityList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/place/GetAllPlaces', { headers: this.headersVar });
  }

  getCountriesList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/place/GetCountries', { headers: this.headersVar });
  }

  //Admin Add place
  addPlace(placeData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/place/AddPlaceDetails', placeData, { headers: this.headersVar });
  }

  // Delete Place ById
  deletePlace(id: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/place/DeletePlaceAsync/' + id, {}, { headers: this.headersVar });
  }

  // Upadate Place 
  updatePlace(updatePlace: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/place/UpdatePlaceRequest', updatePlace, { headers: this.headersVar });
  }

  // Upadate Place 
  uploadCityCsv(uploadedCsv: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'PdfBooking/UploadCsv', uploadedCsv, { headers: this.headersVar });
  }

  //Edit Place ById 
  GetPlaceById(id: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + `admin/place/GetPlaceDetailsById/` + id, { headers: this.headersVar });
  }
  //Upload Place Images
  uploadPlaceImages(formData: FormData) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + `admin/place/UploadPlaceImages`, formData);
  }

  // =====================================================================================================================================================================
  // ------------------------------------------------------------------| Admin Rejected Packages Page APIs |--------------------------------------------------------------
  // =====================================================================================================================================================================

  // Admin Package
  getRejectedPackageDetails(filterTerms: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/package/GetRejectPackageDetails', { params: filterTerms, headers: this.headersVar });
  }

  //Admin approve package
  approveRejectedPackage(packageData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/package/FinalPackageStatus', packageData, { headers: this.headersVar });
  }

  // =====================================================================================================================================================================
  // -------------------------------------------------------------------------| Admin Role Page APIs |--------------------------------------------------------------------
  // =====================================================================================================================================================================

  getRoleWiseList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'RoleWiseModule/GetRoleWiseModule', { headers: this.headersVar });
  }

  addNewRoleWise(roleWiseData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'RoleWiseModule/AddOrUpdateRoleWiseModule', roleWiseData, { headers: this.headersVar });
  }

  //Edit User ById 
  GetRoleWiseById(id: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + `RoleWiseModule/RoleWiseModuleById`, { params: id, headers: this.headersVar });
  }

  // Upadate User 
  updateRoleWise(updateRoleWise: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'RoleWiseModule/UpdateRoleWiseModule', updateRoleWise, { headers: this.headersVar });
  }

  deleteRoleWise(id: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'RoleWiseModule/' + id, {}, { headers: this.headersVar });
  }

  GetRoleWiseByRoleId(roleId: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + `RoleWiseModule/GetRoleWiseModule`, { params: roleId, headers: this.headersVar });
  }

  // Admin Get Role List
  getRoleList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'RoleMaster/GetRoleMaster', { headers: this.headersVar });
  }

  //Admin Add Role
  addNewRole(roleData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'RoleMaster/AddRoleMaster', roleData, { headers: this.headersVar });
  }

  //Edit Role ById 
  GetRoleById(id: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + `RoleMaster/RoleById`, { params: id, headers: this.headersVar });
  }

  // Upadate Role 
  updateRole(updateRole: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'RoleMaster/UpdateRoleMaster', updateRole, { headers: this.headersVar });
  }

  deleteRole(id: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'RoleMaster/' + id, {}, { headers: this.headersVar });
  }

  // =====================================================================================================================================================================
  // -------------------------------------------------------------------------| Admin User Page APIs |--------------------------------------------------------------------
  // =====================================================================================================================================================================

  // Admin Get User List
  getUserList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'UserMaster/GetUserMaster', { headers: this.headersVar });
  }

  addNewUser(userData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'UserMaster/AddUserMaster', userData, { headers: this.headersVar });
  }

  //Edit User ById 
  GetUserById(id: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + `UserMaster/UserMasterById`, { params: id, headers: this.headersVar });
  }

  // Upadate User 
  updateUser(updateUser: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'UserMaster/UpdateUserMaster', updateUser, { headers: this.headersVar });
  }

  deleteUser(userData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'UserMaster/deleteUser', userData, { headers: this.headersVar });
  }

  // =====================================================================================================================================================================
  // -----------------------------------------------------------------------| Admin Vehicle Page APIs |-------------------------------------------------------------------
  // =====================================================================================================================================================================

  // Admin Get Vehicle List
  getVehicleList(placeId: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/Vehicle/GetAllVehicle', { params: placeId, headers: this.headersVar });
  }

  // Admin Get Vehicle List by Id
  getVehicleDetailsById(vehicleId: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/Vehicle/' + vehicleId, { headers: this.headersVar });
  }


  //Admin Add Vehicle
  addNewVehicle(vehicleData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/Vehicle/AddVehicle', vehicleData, { headers: this.headersVar });
  }

  //Admin Add Vehicle
  updateVehicle(vehicleData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/Vehicle/UpdateVehicle', vehicleData, { headers: this.headersVar });
  }

  //Admin Add Vehicle
  deleteVehicle(vehicleId: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'admin/Vehicle/DeleteVehicle/' + vehicleId, {}, { headers: this.headersVar });
  }

  //Upload vehicle Images
  uploadVehicleImages(formData: FormData) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + `admin/vehicle/UploadVehicleImages`, formData);
  }



  // =====================================================================================================================================================================
  // ------------------------------------------------------------------| Admin Contact-Us Inquiry Page APIs |-------------------------------------------------------------
  // =====================================================================================================================================================================

  getContactusInquiryList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'Profile/GetContactusInquiryList', { headers: this.headersVar });
  }

  // =====================================================================================================================================================================
  // --------------------------------------------------------------------| Admin Custom Inquiry Page APIs |---------------------------------------------------------------
  // =====================================================================================================================================================================

  // Admin Custom Package Inquiry
  getCustomInquiryList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'CustomPackageInquiryDetails/GetCustomPackageInquiryList', { headers: this.headersVar });
  }
  // Admin AI Custom Package Inquiry
  getAICustomInquiryList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'AIPlannerInquiryDetails/GetAICustomPackageInquiryList', { headers: this.headersVar });
  }

  // =====================================================================================================================================================================
  // --------------------------------------------------------------------| Admin Kumbh Inquiry Page APIs |----------------------------------------------------------------
  // =====================================================================================================================================================================

  getKumbhInquiryList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'CustomPackageInquiryDetails/GetKumbhPackageInquiryList', { headers: this.headersVar });
  }


  // =====================================================================================================================================================================
  // -------------------------------------------------------------------| Admin standard Inquiry Page APIs |--------------------------------------------------------------
  // =====================================================================================================================================================================

  // Admin Standard Package Inquiry
  getInquiryList(params) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'AdminBooking/GetInquiryList', { params: params, headers: this.headersVar });
  }

  inquiryConfirm(bookingData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'CustomPackageInquiryDetails/InquiryConfirm', bookingData, { headers: this.headersVar });
  }

  inquiryCancel(bookingData: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'CustomPackageInquiryDetails/InquiryCancle', bookingData, { headers: this.headersVar });
  }

  // =====================================================================================================================================================================
  // ---------------------------------------------------------------| Admin Tending Festival Inquiry Page APIs |----------------------------------------------------------
  // =====================================================================================================================================================================

  getTrendingfestivalInquiryList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'CustomPackageInquiryDetails/GetTrendingFestivalInquiryList', { headers: this.headersVar });
  }

  // =====================================================================================================================================================================
  // ---------------------------------------------------------------------------| Admin Common APIs |---------------------------------------------------------------------
  // =====================================================================================================================================================================

  getBookingItineraryByBookingId(id: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'BookingItinerary/GetBookingDetailsByBookingId/' + id, { headers: this.headersVar });
  }

  getItineraryDataByBookingId(bookingId: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'BookingItinerary/GetItineraries/' + bookingId, { headers: this.headersVar });
  }

  // Get Itinerary Data By PlaceId
  getMedicalHistoryDataByPlaceId(bookingID: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'AdminBooking/GetMedicalHistoryByBookingID/' + bookingID, { headers: this.headersVar });
  }

  // Admin Place List
  getAdminPlaceList() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'admin/place/GetAllPlaces', { headers: this.headersVar });
  }

  getBookingItineraryById(id: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'BookingItinerary/' + id, { headers: this.headersVar });
  }

   // Booking User by BookingId
   getBookingUserById(id: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'AdminBooking/' + id, { headers: this.headersVar });
  }

  // Get Assign Tour Manager
  getTourmanagerDetails() {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'TourManager/TourManagerList', { headers: this.headersVar });
  }


  // Add Assign Tour Manager
  addAssignTourManager(addTour: any) {
    this.setHeaders();
    return this.http.post(this.commonService.rootData.rootUrl + 'TourManager', addTour, { headers: this.headersVar });
  }

  // =====================================================================================================================================================================
  // ---------------------------------------------------------------------------| Other Admin APIs |----------------------------------------------------------------------
  // =====================================================================================================================================================================

  // Get Vehicle By Vehicle Id
  getVehicleByVehicleId(vehicleId: any) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'Vehicle/' + vehicleId, { headers: this.headersVar });
  }

  getBookingPaymentDetails(params) {
    this.setHeaders();
    return this.http.get(this.commonService.rootData.rootUrl + 'CustomPackageInquiryDetails/GetPaymentDetails', { params: params, headers: this.headersVar });
  }

}
